import React from "react";

import { Grid, Typography } from "@mui/material";
import { useStaticQuery, graphql } from "gatsby";

import ProjectPost from "./ProjectPost";
import { Box1400 } from "./styles";

const getData = graphql`
  query ProjectPost {
    allMarkdownRemark(filter: { fileAbsolutePath: { glob: "**/Projects/*" } }) {
      edges {
        node {
          id
          frontmatter {
            thumbnail {
              childImageSharp {
                gatsbyImageData(
                  quality: 100
                  placeholder: BLURRED
                  layout: FULL_WIDTH
                )
              }
            }
            title
            date
            slug
            client
            tags
            description
            featuredImage {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED, quality: 100)
              }
            }
          }
          rawMarkdownBody
        }
      }
    }
  }
`;

const FeaturedProjects = () => {
  const { allMarkdownRemark } = useStaticQuery(getData);
  const edges = allMarkdownRemark.edges;
  console.log("edges", allMarkdownRemark.edges);
  return (
    <Box1400 mt={10}>
      <Typography variant="h2neon">Featured Projects</Typography>
      <Grid container spacing={3}>
        {edges.map((data, i) => {
          return <ProjectPost key={`project-${i}`} node={data.node} i={i} />;
        })}
      </Grid>
    </Box1400>
  );
};

export default FeaturedProjects;
